import { PAGE_NAME, usePendingReferral } from '@orcar/common-d2c';
import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import CustomerServicePage from '@/pages/customerService/CustomerServicePage';
import EventDetailPage from '@/pages/event/EventDetailPage';
import EventPage from '@/pages/event/EventPage';
import FindReservationPage from '@/pages/FindReservationPage';
import GuidePage from '@/pages/guide/GuidePage';
import HomePage from '@/pages/home/HomePage';
import InvitePage from '@/pages/invite/InvitePage';
import KakaoLoginRedirectPage from '@/pages/login/kakao/KakaoLoginRedirectPage';
import NaverLoginRedirectPage from '@/pages/login/naver/NaverLoginRedirectPage';
import MustReadPage from '@/pages/mustRead/MustReadPage';
import MyPage from '@/pages/mypage/Mypage';
import ReservationDetailPage from '@/pages/mypage/reservationDetail/ReservationDetailPage';
import NotFound from '@/pages/NotFound';
import PolicyPage from '@/pages/policy/PolicyPage';
import RentInfoPage from '@/pages/rentInfo/RentInfoPage';
import ConfirmPaymentPage from '@/pages/reservation/payment/confirm/ConfirmPaymentPage';
import PaymentFailPage from '@/pages/reservation/payment/fail/PaymentFailPage';
import PaymentPage from '@/pages/reservation/payment/PaymentPage';
import RequestPaymentPage from '@/pages/reservation/payment/request/RequestPaymentPage';
import LongTermRentalSearchPage from '@/pages/search/longTermRental/LongTermRentalPage';
import SearchPage from '@/pages/search/SearchPage';
import ServicePage from '@/pages/service/ServicePage';

declare global {
  interface Window {
    wcs_add?: Record<string, any>;
    wcs?: {
      inflow: (domain: string) => void;
      trans: (conv: Record<string, any>) => void;
    };
  }
}

declare function wcs_do(): void;

const App = () => {
  const location = useLocation();

  // 초대 링크(?referral=코드) 캡처 + 로그인 시 자동 적용
  usePendingReferral();

  useEffect(() => {
    const naverWcsLogSrc = '//wcs.naver.net/wcslog.js';

    let script: HTMLScriptElement | null = document.querySelector(
      `script[src="${naverWcsLogSrc}"]`,
    );

    const executeWcs = () => {
      if (window.wcs) {
        if (!window.wcs_add) window.wcs_add = {};
        window.wcs_add['wa'] = 's_55a24bd3574d'; // 사이트 식별자 설정
        window.wcs.inflow('jejurorentcar.com'); // inflow 설정
        wcs_do(); // PV 이벤트 전송
      }
    };

    if (!script) {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = naverWcsLogSrc;
      script.async = true;
      script.onload = executeWcs; // 스크립트 로드 후 실행
      document.body.appendChild(script);
    } else {
      executeWcs(); // 스크립트가 이미 로드된 경우 즉시 실행
    }
  }, [location]);

  return (
    <Routes>
      <Route path={PAGE_NAME.index} element={<HomePage />} />
      <Route path='/invite/:code' element={<InvitePage />} />
      <Route path={PAGE_NAME.search} element={<SearchPage />} />
      <Route path={PAGE_NAME.payment} element={<PaymentPage />} />
      <Route
        path={PAGE_NAME.request_payment}
        element={<RequestPaymentPage />}
      />
      <Route
        path={PAGE_NAME.confirm_payment}
        element={<ConfirmPaymentPage />}
      />
      <Route path={PAGE_NAME.payment_fail} element={<PaymentFailPage />} />
      <Route path={PAGE_NAME.rent_info} element={<RentInfoPage />} />
      <Route
        path={PAGE_NAME.find_reservation}
        element={<FindReservationPage />}
      />
      <Route path={PAGE_NAME.my_page + '/*'} element={<MyPage />} />
      <Route
        path={PAGE_NAME.reservation_detail + '/:reservationId'}
        element={<ReservationDetailPage />}
      />
      <Route path={PAGE_NAME.cs_center} element={<CustomerServicePage />} />
      <Route path='/guide/:topic' element={<GuidePage />} />
      <Route path='/service' element={<ServicePage />} />
      <Route path={PAGE_NAME.event} element={<EventPage />} />
      <Route path={`${PAGE_NAME.event}/:id`} element={<EventDetailPage />} />
      <Route path={PAGE_NAME.policy} element={<PolicyPage />} />
      <Route
        path={PAGE_NAME.login + '/kakao'}
        element={<KakaoLoginRedirectPage />}
      />
      <Route
        path={PAGE_NAME.login + '/naver'}
        element={<NaverLoginRedirectPage />}
      />
      <Route path='/long-term-rental' element={<LongTermRentalSearchPage />} />
      <Route path='/must-read' element={<MustReadPage />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  );
};

export default App;
